import { fromPairs } from '@domain/utils';
import {
  DesktopSettings,
  LegacyRegistryAccessorItem,
  RegistrySettingItem,
} from '@honestica/electron-bridge-typing';
import { parseRegistrySetting } from '@launcher/utils';

// SECURITY (VULN-2157): temporary compatibility branch, to be deleted.
// Desktop builds older than #4682 only expose getLifenSettingsRegistryAccessor, which is
// backed by the vulnerable renderer-controlled registry access (cmd.exe command injection).
// It must stay only until the patched desktop app is deployed everywhere, then be removed
// together with LegacyRegistryAccessorItem and the legacy branch of readRegistrySettings.
async function readLegacyRegistrySettings(
  accessors: LegacyRegistryAccessorItem[],
): Promise<RegistrySettingItem[]> {
  return Promise.all(
    accessors.map(async (accessor) => ({
      key: accessor.key,
      value: (await accessor.get('value'))?.value ?? undefined,
    })),
  );
}

async function readRegistrySettings(): Promise<RegistrySettingItem[]> {
  if (window.electron.getLifenSettingsFromRegistry) {
    return window.electron.getLifenSettingsFromRegistry();
  }

  // TODO(VULN-2157): remove this legacy branch once the patched desktop app is deployed everywhere
  if (window.electron.getLifenSettingsRegistryAccessor) {
    return readLegacyRegistrySettings(await window.electron.getLifenSettingsRegistryAccessor());
  }

  return [];
}

export async function getSettingsFromRegistry(): Promise<Partial<DesktopSettings>> {
  const items = (await readRegistrySettings()).map(parseRegistrySetting);

  return fromPairs(items.filter((item) => item !== undefined));
}
